export default __webpack_public_path__ + "static/media/featured-item-17.11bd61d0.png";